"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var failedPaymentErrorStyles = styles_1.makeStyles(function () { return ({
    icon: {},
    subTitle: {
        marginBottom: '25px',
    },
    email: {},
    description: {},
    container: {
        position: 'relative',
    },
}); }, { name: 'Gql_FailedPaymentError' });
exports.default = failedPaymentErrorStyles;
